import React, { useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import useInvoiceApi from "../../../hooks/useInvoiceApi";
import { formatMoney } from "../../../features/utils/formatMoney";
import { getCurrencySymbol } from "../../../features/utils/countires";
import moment from "moment";

export const DeleteServiceModal = ({ setOpen, open, service }) => {
  const { deleteService } = useInvoiceApi();
  const [loading, setLoading] = useState(false);

  const handleClose = () => setOpen(false);
  const handleConfirm = async () => {
    await deleteService({
      setLoading,
      id: service?._id,
      callback: () => {
        setOpen(false);
      },
    });
  };

  const Footer = () => (
    <div className="w-full flex flex-col static bottom-0">
      <hr className="border-gray-300 my-3 mb-6" />
      <div className="flex gap-4 items-center">
        <button
          className="flex items-center justify-center text-black px-10 py-4 rounded-lg text-xs sm:text-lg"
          onClick={handleClose}
        >
          <span>Cancel</span>
        </button>
        <button
          className="bg-primary1 disabled:bg-gray-500 disabled:cursor-not-allowed flex items-center justify-center text-white w-full py-4 rounded-lg text-xs sm:text-lg"
          onClick={handleConfirm}
        >
          {loading ? <div className="buttonLoader" /> : <span>Confirm</span>}
        </button>
      </div>
    </div>
  );

  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      secondary
      padding="px-4 py-6"
      title="Delete service"
      subTitle="Are you sure you want to delete this service?"
      footer={<Footer />}
    >
      <div className="w-full flex flex-col">
        <div className="relative overflow-x-auto flex flex-col scroll-hide px-4">
          <div className="w-full gap-2 flex flex-col">
            <div className="flex w-full p-4 bg-gray-100 rounded-md flex-col ">
              <span className="text-gray-500 text-sm">Title</span>
              <span className="text-sm">{service?.title}</span>
            </div>
            <div className="flex w-full p-4 bg-gray-100 rounded-md flex-col ">
              <span className="text-gray-500 text-sm">Description</span>
              <span className="text-sm">
                {service?.description?.join("\n")}
              </span>
            </div>
            <div className="flex w-full p-4 bg-gray-100 rounded-md flex-col ">
              <span className="text-gray-500 text-sm">Price</span>
              <span className="text-sm">
                {formatMoney(
                  service?.unitPrice,
                  getCurrencySymbol(service?.currency)
                )}
              </span>
            </div>
            <div className="flex w-full p-4 bg-gray-100 rounded-md flex-col ">
              <span className="text-gray-500 text-sm">Created at</span>
              <span className="text-sm">
                {moment(service?.createdAt).format("MMMM DD, YYYY")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};
